import { render, staticRenderFns } from "./BiddersChat.vue?vue&type=template&id=45277d54&scoped=true&"
import script from "./BiddersChat.vue?vue&type=script&lang=js&"
export * from "./BiddersChat.vue?vue&type=script&lang=js&"
import style0 from "./BiddersChat.vue?vue&type=style&index=0&id=45277d54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45277d54",
  null
  
)

export default component.exports